import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { calcExactPositionOrRandomFromSize, clamp, getDistance, getParticleBaseVelocity, getParticleDirectionAngle, getRandom, getRangeValue, getValue, randomInRange, setRangeValue } from "../Utils/NumberUtils";
import { deepExtend, getPosition, initParticleNumericAnimationValue, isInArray, itemFromSingleOrMultiple } from "../Utils/Utils";
import { getHslFromAnimation, rangeColorToRgb } from "../Utils/ColorUtils";
import { Interactivity } from "../Options/Classes/Interactivity/Interactivity";
import { Vector } from "./Utils/Vector";
import { Vector3d } from "./Utils/Vector3d";
import { alterHsl } from "../Utils/CanvasUtils";
import { errorPrefix } from "./Utils/Constants";
import { loadParticlesOptions } from "../Utils/OptionsUtils";

var fixOutMode = function fixOutMode(data) {
  if (!isInArray(data.outMode, data.checkModes)) {
    return;
  }

  var diameter = data.radius * 2;

  if (data.coord > data.maxCoord - diameter) {
    data.setCb(-data.radius);
  } else if (data.coord < diameter) {
    data.setCb(data.radius);
  }
};

export var Particle = /*#__PURE__*/function () {
  function Particle(engine, id, container, position, overrideOptions, group) {
    var _this = this;

    _classCallCheck(this, Particle);

    this.container = container;

    this._calcPosition = function (container, position, zIndex) {
      var _outModes$left, _outModes$right, _outModes$top, _outModes$bottom;

      var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      var _iterator = _createForOfIteratorHelper(container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          var pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, _this) : undefined;

          if (pluginPos) {
            return Vector3d.create(pluginPos.x, pluginPos.y, zIndex);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var canvasSize = container.canvas.size,
          exactPosition = calcExactPositionOrRandomFromSize({
        size: canvasSize,
        position: position
      }),
          pos = Vector3d.create(exactPosition.x, exactPosition.y, zIndex),
          radius = _this.getRadius(),
          outModes = _this.options.move.outModes,
          fixHorizontal = function fixHorizontal(outMode) {
        fixOutMode({
          outMode: outMode,
          checkModes: ["bounce", "bounce-horizontal"],
          coord: pos.x,
          maxCoord: container.canvas.size.width,
          setCb: function setCb(value) {
            return pos.x += value;
          },
          radius: radius
        });
      },
          fixVertical = function fixVertical(outMode) {
        fixOutMode({
          outMode: outMode,
          checkModes: ["bounce", "bounce-vertical"],
          coord: pos.y,
          maxCoord: container.canvas.size.height,
          setCb: function setCb(value) {
            return pos.y += value;
          },
          radius: radius
        });
      };

      fixHorizontal((_outModes$left = outModes.left) !== null && _outModes$left !== void 0 ? _outModes$left : outModes.default);
      fixHorizontal((_outModes$right = outModes.right) !== null && _outModes$right !== void 0 ? _outModes$right : outModes.default);
      fixVertical((_outModes$top = outModes.top) !== null && _outModes$top !== void 0 ? _outModes$top : outModes.default);
      fixVertical((_outModes$bottom = outModes.bottom) !== null && _outModes$bottom !== void 0 ? _outModes$bottom : outModes.default);

      if (_this._checkOverlap(pos, tryCount)) {
        return _this._calcPosition(container, undefined, zIndex, tryCount + 1);
      }

      return pos;
    };

    this._calculateVelocity = function () {
      var baseVelocity = getParticleBaseVelocity(_this.direction),
          res = baseVelocity.copy(),
          moveOptions = _this.options.move;

      if (moveOptions.direction === "inside" || moveOptions.direction === "outside") {
        return res;
      }

      var rad = Math.PI / 180 * getRangeValue(moveOptions.angle.value),
          radOffset = Math.PI / 180 * getRangeValue(moveOptions.angle.offset),
          range = {
        left: radOffset - rad / 2,
        right: radOffset + rad / 2
      };

      if (!moveOptions.straight) {
        res.angle += randomInRange(setRangeValue(range.left, range.right));
      }

      if (moveOptions.random && typeof moveOptions.speed === "number") {
        res.length *= getRandom();
      }

      return res;
    };

    this._checkOverlap = function (pos) {
      var tryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var collisionsOptions = _this.options.collisions,
          radius = _this.getRadius();

      if (!collisionsOptions.enable) {
        return false;
      }

      var overlapOptions = collisionsOptions.overlap;

      if (overlapOptions.enable) {
        return false;
      }

      var retries = overlapOptions.retries;

      if (retries >= 0 && tryCount > retries) {
        throw new Error("".concat(errorPrefix, " particle is overlapping and can't be placed"));
      }

      return !!_this.container.particles.find(function (particle) {
        return getDistance(pos, particle.position) < radius + particle.getRadius();
      });
    };

    this._getRollColor = function (color) {
      var _this$roll$angle;

      if (!color || !_this.roll || !_this.backColor && !_this.roll.alter) {
        return color;
      }

      var backFactor = _this.roll.horizontal && _this.roll.vertical ? 2 : 1,
          backSum = _this.roll.horizontal ? Math.PI / 2 : 0,
          rolled = Math.floor((((_this$roll$angle = _this.roll.angle) !== null && _this$roll$angle !== void 0 ? _this$roll$angle : 0) + backSum) / (Math.PI / backFactor)) % 2;

      if (!rolled) {
        return color;
      }

      if (_this.backColor) {
        return _this.backColor;
      }

      if (_this.roll.alter) {
        return alterHsl(color, _this.roll.alter.type, _this.roll.alter.value);
      }

      return color;
    };

    this._initPosition = function (position) {
      var _this$options$move$ce, _this$options$move$ce2;

      var container = _this.container,
          zIndexValue = getRangeValue(_this.options.zIndex.value);
      _this.position = _this._calcPosition(container, position, clamp(zIndexValue, 0, container.zLayers));
      _this.initialPosition = _this.position.copy();
      var canvasSize = container.canvas.size;
      _this.moveCenter = _objectSpread(_objectSpread({}, getPosition(_this.options.move.center, canvasSize)), {}, {
        radius: (_this$options$move$ce = _this.options.move.center.radius) !== null && _this$options$move$ce !== void 0 ? _this$options$move$ce : 0,
        mode: (_this$options$move$ce2 = _this.options.move.center.mode) !== null && _this$options$move$ce2 !== void 0 ? _this$options$move$ce2 : "percent"
      });
      _this.direction = getParticleDirectionAngle(_this.options.move.direction, _this.position, _this.moveCenter);

      switch (_this.options.move.direction) {
        case "inside":
          _this.outType = "inside";
          break;

        case "outside":
          _this.outType = "outside";
          break;
      }

      _this.offset = Vector.origin;
    };

    this._loadShapeData = function (shapeOptions, reduceDuplicates) {
      var shapeData = shapeOptions.options[_this.shape];

      if (!shapeData) {
        return;
      }

      return deepExtend({
        close: shapeOptions.close,
        fill: shapeOptions.fill
      }, itemFromSingleOrMultiple(shapeData, _this.id, reduceDuplicates));
    };

    this._engine = engine;
    this.init(id, position, overrideOptions, group);
  }

  _createClass(Particle, [{
    key: "destroy",
    value: function destroy(override) {
      if (this.unbreakable || this.destroyed) {
        return;
      }

      this.destroyed = true;
      this.bubble.inRange = false;
      this.slow.inRange = false;
      var container = this.container,
          pathGenerator = this.pathGenerator;

      var _iterator2 = _createForOfIteratorHelper(container.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              plugin = _step2$value[1];

          if (plugin.particleDestroyed) {
            plugin.particleDestroyed(this, override);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(container.particles.updaters),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var updater = _step3.value;

          if (updater.particleDestroyed) {
            updater.particleDestroyed(this, override);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (pathGenerator) {
        pathGenerator.reset(this);
      }
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;

      var _iterator4 = _createForOfIteratorHelper(container.plugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          container.canvas.drawParticlePlugin(plugin, this, delta);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      container.canvas.drawParticle(this, delta);
    }
  }, {
    key: "getFillColor",
    value: function getFillColor() {
      var _this$bubble$color;

      return this._getRollColor((_this$bubble$color = this.bubble.color) !== null && _this$bubble$color !== void 0 ? _this$bubble$color : getHslFromAnimation(this.color));
    }
  }, {
    key: "getMass",
    value: function getMass() {
      return Math.pow(this.getRadius(), 2) * Math.PI / 2;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.position.x + this.offset.x,
        y: this.position.y + this.offset.y,
        z: this.position.z
      };
    }
  }, {
    key: "getRadius",
    value: function getRadius() {
      var _this$bubble$radius;

      return (_this$bubble$radius = this.bubble.radius) !== null && _this$bubble$radius !== void 0 ? _this$bubble$radius : this.size.value;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor() {
      var _this$bubble$color2;

      return this._getRollColor((_this$bubble$color2 = this.bubble.color) !== null && _this$bubble$color2 !== void 0 ? _this$bubble$color2 : getHslFromAnimation(this.strokeColor));
    }
  }, {
    key: "init",
    value: function init(id, position, overrideOptions, group) {
      var _shapeData$fill, _shapeData$close, _drawer;

      var container = this.container,
          engine = this._engine;
      this.id = id;
      this.group = group;
      this.fill = true;
      this.pathRotation = false;
      this.close = true;
      this.lastPathTime = 0;
      this.destroyed = false;
      this.unbreakable = false;
      this.rotation = 0;
      this.misplaced = false;
      this.retina = {
        maxDistance: {}
      };
      this.outType = "normal";
      this.ignoresResizeRatio = true;
      var pxRatio = container.retina.pixelRatio,
          mainOptions = container.actualOptions,
          particlesOptions = loadParticlesOptions(this._engine, container, mainOptions.particles),
          shapeType = particlesOptions.shape.type,
          reduceDuplicates = particlesOptions.reduceDuplicates;
      this.shape = itemFromSingleOrMultiple(shapeType, this.id, reduceDuplicates);
      var shapeOptions = particlesOptions.shape;

      if (overrideOptions && overrideOptions.shape && overrideOptions.shape.type) {
        var overrideShapeType = overrideOptions.shape.type,
            shape = itemFromSingleOrMultiple(overrideShapeType, this.id, reduceDuplicates);

        if (shape) {
          this.shape = shape;
          shapeOptions.load(overrideOptions.shape);
        }
      }

      this.shapeData = this._loadShapeData(shapeOptions, reduceDuplicates);
      particlesOptions.load(overrideOptions);
      var shapeData = this.shapeData;

      if (shapeData) {
        particlesOptions.load(shapeData.particles);
      }

      var interactivity = new Interactivity(engine, container);
      interactivity.load(container.actualOptions.interactivity);
      interactivity.load(particlesOptions.interactivity);
      this.interactivity = interactivity;
      this.fill = (_shapeData$fill = shapeData === null || shapeData === void 0 ? void 0 : shapeData.fill) !== null && _shapeData$fill !== void 0 ? _shapeData$fill : particlesOptions.shape.fill;
      this.close = (_shapeData$close = shapeData === null || shapeData === void 0 ? void 0 : shapeData.close) !== null && _shapeData$close !== void 0 ? _shapeData$close : particlesOptions.shape.close;
      this.options = particlesOptions;
      var pathOptions = this.options.move.path;
      this.pathDelay = getValue(pathOptions.delay) * 1000;

      if (pathOptions.generator) {
        this.pathGenerator = this._engine.plugins.getPathGenerator(pathOptions.generator);

        if (this.pathGenerator && container.addPath(pathOptions.generator, this.pathGenerator)) {
          this.pathGenerator.init(container);
        }
      }

      container.retina.initParticle(this);
      this.size = initParticleNumericAnimationValue(this.options.size, pxRatio);
      this.bubble = {
        inRange: false
      };
      this.slow = {
        inRange: false,
        factor: 1
      };

      this._initPosition(position);

      this.initialVelocity = this._calculateVelocity();
      this.velocity = this.initialVelocity.copy();
      this.moveDecay = 1 - getRangeValue(this.options.move.decay);
      var particles = container.particles;
      particles.needsSort = particles.needsSort || particles.lastZIndex < this.position.z;
      particles.lastZIndex = this.position.z;
      this.zIndexFactor = this.position.z / container.zLayers;
      this.sides = 24;
      var drawer = container.drawers.get(this.shape);

      if (!drawer) {
        drawer = this._engine.plugins.getShapeDrawer(this.shape);

        if (drawer) {
          container.drawers.set(this.shape, drawer);
        }
      }

      if (drawer && drawer.loadShape) {
        drawer.loadShape(this);
      }

      var sideCountFunc = (_drawer = drawer) === null || _drawer === void 0 ? void 0 : _drawer.getSidesCount;

      if (sideCountFunc) {
        this.sides = sideCountFunc(this);
      }

      this.spawning = false;
      this.shadowColor = rangeColorToRgb(this.options.shadow.color);

      var _iterator5 = _createForOfIteratorHelper(container.particles.updaters),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var updater = _step5.value;
          updater.init(this);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(container.particles.movers),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var mover = _step6.value;
          mover.init && mover.init(this);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      if (drawer && drawer.particleInit) {
        drawer.particleInit(container, this);
      }

      var _iterator7 = _createForOfIteratorHelper(container.plugins),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _step7$value = _slicedToArray(_step7.value, 2),
              plugin = _step7$value[1];

          plugin.particleCreated && plugin.particleCreated(this);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "isInsideCanvas",
    value: function isInsideCanvas() {
      var radius = this.getRadius(),
          canvasSize = this.container.canvas.size,
          position = this.position;
      return position.x >= -radius && position.y >= -radius && position.y <= canvasSize.height + radius && position.x <= canvasSize.width + radius;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
  }, {
    key: "reset",
    value: function reset() {
      var _iterator8 = _createForOfIteratorHelper(this.container.particles.updaters),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var updater = _step8.value;
          updater.reset && updater.reset(this);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }]);

  return Particle;
}();